import { Button } from '@mui/material';
import Card from '../../../../common/card';
import Select from '../../../../common/select';
import l from '../../../../../lang';
import { FlowType } from '../../../../../store/payouts/interfaces';
import { payoutCountryOptions } from '../utils';
import { ReactComponent as WorldIcon } from '../../../../../assets/icons/world.svg';
import { ReactComponent as BriefcaseIcon } from '../../../../../assets/icons/briefcase.svg';
import { usePayouts } from '../../../../../store/payouts';
import { useEffect, useState } from 'react';
import DialogOtpNotSet from '../dialog-otp-not-set';
import { useDashboard } from '../../../../../store/dashboard';
import { Routes } from '../../../../../config/routes';
import { useHistory } from 'react-router-dom';

interface CountrySelectionProps {
  country: string;
  flowType: FlowType;
  onCountryChange: (country: string) => void;
  onFlowTypeChange: (flowType: FlowType) => void;
  onCancel: () => void;
  onNext: () => void;
}

const CountrySelection = ({
  country,
  flowType,
  onCountryChange,
  onFlowTypeChange,
  onCancel,
  onNext,
}: CountrySelectionProps) => {
  const [openDialogOtpNotSet, setOpenDialogOtpNotSet] = useState(false);
  const { isOtpConfigured } = usePayouts();
  const { setShowTwoFactorAuthSetup } = useDashboard();
  const history = useHistory();

  useEffect(() => {
    setOpenDialogOtpNotSet(!isOtpConfigured);
  }, [isOtpConfigured]);

  const handleCloseDialogOtpNotSet = (confirm: boolean) => {
    if (confirm) {
      setShowTwoFactorAuthSetup(true);
    } else {
      history.push(Routes.PAYOUTS);
    }

    onCancel();
  };

  return (
    <div className="payout-create__layout">
      {openDialogOtpNotSet && <DialogOtpNotSet onClose={handleCloseDialogOtpNotSet} />}
      <Card>
        <div className="payout-create__card-content">
          <h2>{l('payouts.create.accountData.title')}</h2>
          <p>{l('payouts.create.accountData.subtitle')}</p>
          <div className="transaction_detail__title_section">
            <WorldIcon className="transaction_detail__title_section__icon" />
            {l('payouts.create.accountData.countrySection')}
          </div>
          <Select
            name="country"
            label={l('payouts.create.field.country')}
            defaultOptionText={l('payouts.create.field.countryPlaceholder')}
            value={country}
            options={payoutCountryOptions}
            onChange={event => onCountryChange(event.target.value)}
          />
          <br />
          <br />
          <div className="transaction_detail__title_section">
            <BriefcaseIcon className="transaction_detail__title_section__icon" />
            {l('payouts.create.accountData.flowTypeSection')}
          </div>
          <div className="payout-create__flow-selector">
            <Button
              className="payout-create__flow-selector__button"
              variant={flowType === FlowType.B2C ? 'contained' : 'outlined'}
              onClick={() => onFlowTypeChange(FlowType.B2C)}
            >
              {l('payouts.create.flow.person')}
            </Button>
            <Button
              className="payout-create__flow-selector__button"
              variant={flowType === FlowType.B2B ? 'contained' : 'outlined'}
              onClick={() => onFlowTypeChange(FlowType.B2B)}
            >
              {l('payouts.create.flow.business')}
            </Button>
          </div>
          <div className="payout-create__flow-selector__description">
            {flowType === FlowType.B2C
              ? l('payouts.create.flow.personDescription')
              : l('payouts.create.flow.businessDescription')}
          </div>
          <div className="payout-create__buttons">
            <Button
              variant="contained"
              size="large"
              onClick={onCancel}
              sx={{ backgroundColor: '#E8E8E8', color: 'black', ':hover': { backgroundColor: '#D0D0D0' } }}
            >
              {l('common.cancel')}
            </Button>
            <Button variant="contained" size="large" onClick={onNext} disabled={!country}>
              {l('common.next')}
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CountrySelection;
